<template>
  <div class="min-h-screen bg-brand-gray50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <Logo class="text-purple-700 mx-auto h-16 w-auto"/>
    <template v-if="account.schoolId !== 49415">
      <h1 class="mt-6 text-center text-3xl font-bold text-brand-gray-900">{{ account.schoolName }}</h1>
      <CodeLookup v-if="step === 1" @code-validated="validated"/>
      <EmailLookup v-else-if="step === 2"
                   message="Hello, Let's get you registered for your review course"
                   @email-not-found="emailNotFound"
                   @email-validated="emailValidated"
      />
      <CreateAccount v-else-if="step === '3a'"
                     :create-only="true"
                     :email="email"
                     :account="account"
                     :children="children"
                     :registration-code="code"
                     @account-created="accountCreated"
      />
      <Login v-else-if="step === '3b'"
            :user="user"
             @login-complete="loginComplete"
      />
      <ShippingInformation v-else-if="step===4"
                           @shipping-updated="shippingUpdated"
      />
      <CompleteRegistration v-else-if="step === 5"
                            :user="user"
                            :code="code"
                            :shipping-address="shippingAddress"
      />
    </template>
    <template v-else>
      <h1 class="mt-6 text-center text-3xl font-bold text-brand-gray-900">Welcome Future Nurse!</h1>
      <template v-if="registrationOpened()">
        <EmailLookup v-if="step === 1" :ea="true"
                     message="Hello, Let's get you registered for your review course"
                     @email-not-found="emailNotFound"
                     @email-validated="emailValidated"
        />
        <CreateEduAffAccount v-else-if="step === '3a'"
                             :email="email"
                             :account="account"
                             :children="children"
                             @account-created="accountCreated"
        />
        <Login v-else-if="step === '3b'"
               :user="user"
               @login-complete="loginComplete"
        />
        <EduAffCompleteRegistration v-else-if="step === 4" :user="user"/>
      </template>
      <div v-else>
        <p class="mt-6 text-center text-lg text-brand-gray-900">Registration for this term does not open until January 9, 2023.</p>
      </div>
    </template>
  </div>
</template>

<script>
import Logo from './book-store/Logo';
import CodeLookup from './book-store/CodeLookup';
import EmailLookup from './book-store/EmailLookup';
import CreateAccount from './book-store/CreateAccount';
import CompleteRegistration from './book-store/CompleteRegistration';
import Login from './book-store/Login';
import CreateEduAffAccount from './book-store/CreateEduAffAccount';
import EduAffCompleteRegistration from './book-store/EduAffCompleteRegistration';
import ShippingInformation from "./book-store/ShippingInformation";

export default {
  name: 'HealthcareRegistration',
  components: {
    ShippingInformation,
    EduAffCompleteRegistration,
    CreateEduAffAccount, Login, CompleteRegistration, CreateAccount, EmailLookup, CodeLookup, Logo},

  props: {
    account: Object,
    children: Array,
  },

  data() {
    return {
      code: null,
      email: null,
      shippingAddress: null,
      step: 1,
      user: null,
    };
  },

  methods: {
    accountCreated(event) {
      this.user = event.user;
      this.step = 4;
    },

    emailNotFound(event) {
      this.step = '3a';
      this.email = event;
    },

    emailValidated(event) {
      this.step = '3b';
      this.user = event;
    },

    loginComplete() {
      this.step = 4;
    },

    registrationOpened() {
      const openDate = new Date('2023-01-09');
      const now = new Date();
      return now >= openDate;
    },
    shippingUpdated(event) {
      this.step = 5;
      this.shippingAddress = event;
    },

    validated(event) {
      this.code = event;
      this.step = 2;
    },
  },

};
</script>

<style scoped>

</style>